import { format } from "sql-formatter";

const SQL_FORMAT_OPTIONS = {
  language: "tsql" as const,
  keywordCase: "upper" as const,
  tabWidth: 2,
  paramTypes: { named: [":"] satisfies Array<":" | "@" | "$"> },
};

export function formatSql(source: string): string {
  return format(source, SQL_FORMAT_OPTIONS);
}
